import LoadingIndicator from "components/LoadingIndicator";

import BillingDetailsCard from "./components/BillingDetailsCard";
import EditPaymentSourcesCard from "./components/EditPaymentSourcesCard";
import PaymentSourceForm from "./components/PaymentSourceForm";
import PaymentMethodDisplay from "./components/PaymentMethodDisplay";

import Button from "components/Button";

import { usePaymentSources } from "v2/pages/billing/hooks/usePaymentSources";
import { useToasterFromActionData } from "hooks/useToasterFromActionData";
import useBillingInfo from "v2/hooks/billing/useBillingInfo";
import Spinner from "components/Spinner";


export default function PaymentMethodCard() {
  const { paymentSources, paymentSourcesFetcher } = usePaymentSources();
  useToasterFromActionData(paymentSourcesFetcher);
  const { hasWireTransferOnAccount } = useBillingInfo();

  const hasPaymentSources = paymentSources && paymentSources.length > 0;

  // Wire-transfer (VBAN) users see an info banner but can still add/manage backup cards below.
  return (
    <LoadingIndicator fetchers={ [ paymentSourcesFetcher ] } animateWhenSubmitting={ false }>
      <BillingDetailsCard
        id="payment-method"
        title="Payment Method"
        subtitle="Update your payment information"
      >
        <div className="pt-6 flex flex-col gap-4">
          { hasWireTransferOnAccount && (
            <PaymentMethodDisplay
              paymentSource={ undefined }
              onChangeClick={ () => {} }
              showWireTransferBanner
            />
          ) }

          { paymentSources === undefined && (
            // <>TODO loading indicator for the initial data loads</>
            <div className="flex items-center justify-center">
              <Spinner size="MD" />
            </div>
          ) }

          { paymentSources !== undefined && (
            <>
              { hasPaymentSources && (
                <EditPaymentSourcesCard />
              ) }

              {/* show add payment source form if no payment sources */}
              { !hasPaymentSources && (
                <PaymentSourceForm
                  secondaryButton={ (handleClearInputs) =>
                    <Button
                      text="Clear"
                      className="button button-secondary"
                      onClick={ handleClearInputs }
                    />
                  }
                />
              ) }
            </>
          ) }
        </div>
      </BillingDetailsCard>
    </LoadingIndicator>
  );
}
